import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-icon-selector',
  templateUrl: './icon-selector.component.html',
  styleUrl: './icon-selector.component.scss'
})
export class IconSelectorComponent {
  @Input()
  public  nowValue : string = '';

  @Input()
  public selectionEnabled: boolean = true;

  @Input({
    required: true
  })
  public  icons: string[];

  @Output()
  public iconChange = new EventEmitter();

  public showingOptions : boolean = false;

  closeAll(){
    console.log('closeAll called')
    this.showingOptions = false;
  }

  public selectOption(option: string){
    if(this.selectionEnabled){
      this.showingOptions = false;
      this.nowValue = option;
      this.iconChange.emit(this.nowValue)
     
    }
  }


  iconValue = '';

}
